import BaseFormPresenter from "../../../../../components/common/BaseFormPresenter";
import {
  convertTo12Hour,
  formatDate,
  SubmitImg,
} from "../../../../../components/common/Converter";
import { createNotification } from "../../../../../createNotification";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";

class TrainingListFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  onChangeForm(field, value) {
    if (field === "datefrom" || field === "dateto") {
      const dateFrom = field === "datefrom" ? value : this.view.state.datefrom;
      const dateTo = field === "dateto" ? value : this.view.state.dateto;

      if (new Date(dateFrom) > new Date(dateTo)) {
        this.showError("Date from is greater than date To");
      } else {
        this.view.setState({ [field]: value });
      }
    } else {
      this.view.setState({ [field]: value });
    }
  }

  async handleHierarchyChange(object) {
    const formattedObject = Object.keys(object).reduce((acc, key) => {
      // Process only keys that start with "selected"
      if (key.startsWith("selected")) {
        const newKey = key.replace(
          /selected(.)/,
          (match, char) => `selected${char.toUpperCase()}`
        );
        acc[newKey] = object[key]; // Assign transformed key with original value
      }
      return acc;
    }, {});

    this.setState({ ...formattedObject });
  }

  fields = [
    "selectedRegions",
    "selectedOffices",
    "selectedDivisions",
    "selectedSections",
    "selectedUnits",
    "selectedPlantilla",
    "selectedDesignations",
  ];

  async hanldeSubmit() {
    console.log("STGGA: ", this.view.state);
    const regex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/i;
    const personEmail = this.view.state.personEmail;
    if (
      personEmail !== "" &&
      personEmail !== undefined &&
      !regex.test(personEmail)
    ) {
      this.view.showError("Invalid email");
      return;
    }
    const { designations, hierarchy, ...data } = this.view.state;

    if (!this.view.state.selectAllEmployee) {
      // for (const field of this.fields) {
      // const displayFieldName = field
      //   ?.replace("selected", "")
      //   .toLocaleLowerCase();
      if (
        // this.view.state[field].length === 0 &&
        this.view.state.selectedRegions.length === 0 &&
        // this.view.state[displayFieldName].length > 0 &&
        !this.view.state.selectAllEmployee
      ) {
        this.view.showError(`Organizational Structure is required`);
        return;
      } else if (
        // this.view.state[field].length === 0 &&
        this.view.state.selectedDesignations.length === 0 &&
        // this.view.state[displayFieldName].length > 0 &&
        !this.view.state.selectAllEmployee
      ) {
        this.view.showError(`Designation is required`);
        return;
      }
      // }
    }

    const trainingCollateral = this.view.state.trainingcollateral
      ? await SubmitImg(this.view.state.trainingcollateral)
      : [];

    const trainingSignature = this.view.state.trainingsignature
      ? await SubmitImg(this.view.state.trainingsignature)
      : [];
    const trainingDocuments = this.view.state.trainingdocuments
      ? await SubmitImg(this.view.state.trainingdocuments)
      : [];
    if (data.id) {
      const submitData = {
        ...data,
        trainingsignature: trainingSignature,
        trainingcollateral: trainingCollateral,
        trainingdocuments: trainingDocuments,
        ...(this.view.state.stats === "Done" && { completionDate: new Date() }),
        selectAllEmployee: this.view.state.selectAllEmployee,
        // id: this.view.state.objectID,
        date: `${formatDate(data.datefrom)} - ${formatDate(data.dateto)}`,
        time: `${convertTo12Hour(data.timestart)} - ${convertTo12Hour(
          data.timeend
        )}`,
      };
      const myTrainings = await findObjectUseCase().execute("enroll_training", {
        where: { training: data.training },
      });
      upsertUseCase().execute("management_training", submitData);
      if (Object.keys(myTrainings).length > 0) {
        for (const myTraining of myTrainings) {
          const { stats, ...removeStats } = myTraining;
          const update = {
            stats: data.stats,
            ...(this.view.state.stats === "Done" && {
              completionDate: new Date(),
            }),
            ...removeStats,
          };
          upsertUseCase().execute("enroll_training", update);
        }
      }
      this.view.props.closeTrainingForm();
      this.view.props.refetchData();
    } else {
      const submitData = {
        ...data,
        ...(this.view.state.stats === "Done" && { completionDate: new Date() }),
        trainingsignature: trainingSignature,
        trainingcollateral: trainingCollateral,
        trainingdocuments: trainingDocuments,
        date: `${formatDate(data.datefrom)} - ${formatDate(data.dateto)}`,
        time: `${convertTo12Hour(data.timestart)} - ${convertTo12Hour(
          data.timeend
        )}`,
      };
      upsertUseCase().execute("management_training", submitData);

      if (submitData.stats === "Done") {
        const NOTIFICATION_MESSAGE =
          "Training has been completed. You can now evaluate the training.";
        const NOTIFICATION_RECEIVER = ["role:user"];
        const NOTIFICATION_REDIRECT = "training";

        createNotification(
          NOTIFICATION_MESSAGE,
          NOTIFICATION_RECEIVER,
          NOTIFICATION_REDIRECT
        );
      } else {
        //  CREATE NOTIFICATION
        const NOTIFICATION_MESSAGE =
          "You have a new notification for the Employee Training and Development Program";
        const NOTIFICATION_RECEIVER = ["role:user"];
        const NOTIFICATION_REDIRECT = "training";

        createNotification(
          NOTIFICATION_MESSAGE,
          NOTIFICATION_RECEIVER,
          NOTIFICATION_REDIRECT
        );
      }

      this.view.props.closeTrainingForm();
      this.view.props.refetchData();
    }
  }
}

export default TrainingListFormPresenter;
